import styles from "./Footer.module.css";
import { FaInstagram } from "react-icons/fa";

function Footer({ socialLinks, attribution }) {
	return (
		<footer className={styles.footer} aria-label="Site footer">
			<nav className={styles.socials} aria-label="Social links">
				{socialLinks.map((social) => (
					<a
						key={social.label}
						href={social.href}
						target="_blank"
						rel="noopener noreferrer"
					>
						<FaInstagram aria-hidden="true" className={styles.socialIcon} />
						{social.label}
					</a>
				))}
			</nav>

			<p className={styles.attribution}>
				Website powered by{" "}
				<a href={attribution.href} target="_blank" rel="noopener noreferrer">
					{attribution.label}
				</a>
			</p>
		</footer>
	);
}

export default Footer;
